import { Option } from './option';
import { SelectedOption } from './selected-option';
import { OptionIncludeExclude } from './option-include-exclude';

export class MasterOptionsModel {
    public NormalOptions: Option[];
    public QuoteSelectedOptions: SelectedOption[];
    public QuoteCustomOptions: SelectedOption[];
    public IncludeExcludeOptions: OptionIncludeExclude[];
    public AllNormalOptions: Option[];
    public AllSelectedOptions: SelectedOption[];

    constructor() {
        this.NormalOptions = new Array<Option>();
        this.QuoteSelectedOptions = new Array<SelectedOption>();
        this.QuoteCustomOptions = new Array<SelectedOption>();
        this.IncludeExcludeOptions = new Array<OptionIncludeExclude>();
        this.AllNormalOptions = new Array<Option>();
        this.AllSelectedOptions = new Array<SelectedOption>();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/master-options-model.ts